import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';

import { ContentsManageIco, LogoMXspace, ServiceManageIco } from 'components';

import { RootState } from '_reducers';

import * as ROUTES from 'constants/routes';
import { pagemoveSuccess } from '_actions/SideMenuAction';

import './layout.css';
import { StyledUserAdminNav } from './styled';

const { confirm } = Modal;

export default function Sider(props: any) {
  let navigate = useNavigate();
  let location = useLocation();
  const { userData } = useSelector((state: RootState) => state.userReducer);
  const { isChanged } = useSelector((state: RootState) => state.SideMenuReducer);

  const { grade } = userData;

  const dispatch = useDispatch();

  const pagemoveSuccessCallback = useCallback(
    async () => dispatch(await pagemoveSuccess()),
    [dispatch]
  );

  function checkPageMove(path: string) {
    if (isChanged) {
      confirm({
        title: '페이지를 이동하시겠습니까? 변경 사항이 저장되지 않을 수 있습니다.',
        okText: '이동',
        okType: 'primary',
        cancelText: '이동 안함',
        onOk() {
          navigate(path);
          pagemoveSuccessCallback();
        },
      });
    } else {
      navigate(path);
    }
  }

  const menuType = [
    {
      ico: ServiceManageIco,
      title: '서비스 관리',
      sub: [
        {
          title: '계정 관리',
          path: ROUTES.USER_USERLIST_F,
        },
        {
          title: '그룹 관리',
          path: ROUTES.USER_GROUPLIST_F,
        },
        {
          title: '강의 관리',
          path: ROUTES.USER_LECTURES_F,
        },
      ],
    },
    {
      ico: ContentsManageIco,
      title: '콘텐츠 관리',
      sub: [
        {
          title: '파일 관리',
          path: ROUTES.USER_MODELFILEMANAGE_F,
        },
      ],
    },
  ];

  return (
    <StyledUserAdminNav>
      <div className="logo">
        <LogoMXspace />
      </div>
      {menuType.map((menu, index) => (
        <div key={index} className="menu">
          <div className="menu-title">
            <menu.ico />
            <p>{menu.title}</p>
          </div>

          {menu.sub?.map((subMenu, subIndex) => (
            <div
              key={subIndex}
              className={`sub-menu ${location.pathname === `${subMenu.path}` ? 'active' : ''}`}
              onClick={() => checkPageMove(subMenu.path)}
            >
              <p>{subMenu.title}</p>
            </div>
          ))}
        </div>
      ))}
    </StyledUserAdminNav>
  );
}
